import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the notice
    const dismissed = localStorage.getItem('eastend_cookie_notice_dismissed');
    const consent = localStorage.getItem('eastend_cookie_consent');
    
    // Show notice if not dismissed and no consent decision made
    if (!dismissed && !consent) {
      // Small delay to avoid flash on load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    // Grant consent and dismiss
    localStorage.setItem('eastend_cookie_consent', 'granted');
    localStorage.setItem('eastend_cookie_notice_dismissed', 'true');
    
    // Notify pixel if available
    if (window.EastendPixel && window.EastendPixel.grantConsent) {
      window.EastendPixel.grantConsent();
    }
    
    setVisible(false);
  };

  const handleDismiss = () => {
    // Just dismiss without granting enhanced consent
    localStorage.setItem('eastend_cookie_notice_dismissed', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div 
      data-testid="cookie-notice"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-gray-900/95 backdrop-blur-sm border-t border-gray-700 shadow-lg animate-in slide-in-from-bottom duration-300"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-gray-100 text-sm">
          <span className="text-xl">🍪</span>
          <p>
            We use cookies to improve your experience and understand how visitors interact with our site.
            <a 
              href="/privacy" 
              className="text-amber-400 hover:text-amber-300 underline ml-1"
            >
              Learn more
            </a>
          </p>
        </div>
        
        <div className="flex items-center gap-3 flex-shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={handleDismiss}
            className="border-gray-600 text-gray-300 hover:bg-gray-800"
            data-testid="cookie-dismiss"
          >
            Dismiss
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
            className="bg-amber-500 hover:bg-amber-600 text-gray-900 font-semibold"
            data-testid="cookie-accept"
          >
            Accept All
          </Button>
          <button 
            onClick={handleDismiss}
            className="p-1 text-gray-400 hover:text-gray-200 transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
